var map = {
	"./auracoin.png": 60046,
	"./icon-apple": 19605,
	"./icon-apple.vue": 19605,
	"./icon-auracoin": 8210,
	"./icon-auracoin.vue": 8210,
	"./icon-bell": 49223,
	"./icon-bell.vue": 49223,
	"./icon-burger": 83805,
	"./icon-burger.vue": 83805,
	"./icon-calendar": 18835,
	"./icon-calendar.vue": 18835,
	"./icon-camera": 93973,
	"./icon-camera-tilted": 43311,
	"./icon-camera-tilted.vue": 43311,
	"./icon-camera.vue": 93973,
	"./icon-car": 82803,
	"./icon-car.vue": 82803,
	"./icon-caret-down": 87612,
	"./icon-caret-down.vue": 87612,
	"./icon-caret-up": 62502,
	"./icon-caret-up.vue": 62502,
	"./icon-chat-dots": 55892,
	"./icon-chat-dots.vue": 55892,
	"./icon-check-mark": 58189,
	"./icon-check-mark.vue": 58189,
	"./icon-checklist": 53449,
	"./icon-checklist.vue": 53449,
	"./icon-chevron-down": 94060,
	"./icon-chevron-down.vue": 94060,
	"./icon-chevron-left": 59460,
	"./icon-chevron-left copy": 43780,
	"./icon-chevron-left copy.vue": 43780,
	"./icon-chevron-left.vue": 59460,
	"./icon-chevron-right": 6283,
	"./icon-chevron-right copy": 58638,
	"./icon-chevron-right copy.vue": 58638,
	"./icon-chevron-right.vue": 6283,
	"./icon-chevron-up": 67988,
	"./icon-chevron-up.vue": 67988,
	"./icon-close": 51141,
	"./icon-close.vue": 51141,
	"./icon-clouds-sun": 10387,
	"./icon-clouds-sun.vue": 10387,
	"./icon-coins": 12597,
	"./icon-coins.vue": 12597,
	"./icon-contact-list": 47350,
	"./icon-contact-list.vue": 47350,
	"./icon-contact-us": 57705,
	"./icon-contact-us.vue": 57705,
	"./icon-copy": 23105,
	"./icon-copy.vue": 23105,
	"./icon-email": 94310,
	"./icon-email.vue": 94310,
	"./icon-events": 25303,
	"./icon-events.vue": 25303,
	"./icon-exclamation-mark": 9574,
	"./icon-exclamation-mark.vue": 9574,
	"./icon-eye-closed": 5769,
	"./icon-eye-closed.vue": 5769,
	"./icon-eye-open": 26079,
	"./icon-eye-open.vue": 26079,
	"./icon-filter": 79597,
	"./icon-filter.vue": 79597,
	"./icon-holiday": 50815,
	"./icon-holiday.vue": 50815,
	"./icon-home": 65840,
	"./icon-home.vue": 65840,
	"./icon-hourglass": 35497,
	"./icon-hourglass.vue": 35497,
	"./icon-image": 16668,
	"./icon-image.vue": 16668,
	"./icon-inattesa": 3315,
	"./icon-inattesa.vue": 3315,
	"./icon-lens": 75007,
	"./icon-lens.vue": 75007,
	"./icon-lifebuoy": 21320,
	"./icon-lifebuoy.vue": 21320,
	"./icon-link": 26236,
	"./icon-link.vue": 26236,
	"./icon-location": 87404,
	"./icon-location.vue": 87404,
	"./icon-mail": 14654,
	"./icon-mail.vue": 14654,
	"./icon-map": 74459,
	"./icon-map.vue": 74459,
	"./icon-maturato": 48365,
	"./icon-maturato.vue": 48365,
	"./icon-megaphone": 13336,
	"./icon-megaphone.vue": 13336,
	"./icon-menu": 34882,
	"./icon-menu.vue": 34882,
	"./icon-minus": 91775,
	"./icon-minus.vue": 91775,
	"./icon-minute": 59608,
	"./icon-minute.vue": 59608,
	"./icon-money": 20037,
	"./icon-money-transfer": 52650,
	"./icon-money-transfer.vue": 52650,
	"./icon-money.vue": 20037,
	"./icon-network": 73880,
	"./icon-network.vue": 73880,
	"./icon-notifications": 65081,
	"./icon-notifications.vue": 65081,
	"./icon-party-popper": 87573,
	"./icon-party-popper.vue": 87573,
	"./icon-people": 89205,
	"./icon-people.vue": 89205,
	"./icon-plus": 13012,
	"./icon-plus.vue": 13012,
	"./icon-pointer": 70233,
	"./icon-pointer.vue": 70233,
	"./icon-prelevato": 98709,
	"./icon-prelevato.vue": 98709,
	"./icon-restaurant": 98961,
	"./icon-restaurant.vue": 98961,
	"./icon-shopping-bag": 66613,
	"./icon-shopping-bag.vue": 66613,
	"./icon-signpost": 79095,
	"./icon-signpost.vue": 79095,
	"./icon-smile-bag": 36959,
	"./icon-smile-bag.vue": 36959,
	"./icon-star": 31157,
	"./icon-star-full": 63901,
	"./icon-star-full.vue": 63901,
	"./icon-star-half": 91235,
	"./icon-star-half.vue": 91235,
	"./icon-star-ribbon": 23420,
	"./icon-star-ribbon.vue": 23420,
	"./icon-star.vue": 31157,
	"./icon-success-star": 6101,
	"./icon-success-star.vue": 6101,
	"./icon-swimming": 39941,
	"./icon-swimming.vue": 39941,
	"./icon-technical-support": 85902,
	"./icon-technical-support.vue": 85902,
	"./icon-telephone": 726,
	"./icon-telephone.vue": 726,
	"./icon-text": 89223,
	"./icon-text.vue": 89223,
	"./icon-time": 583,
	"./icon-time.vue": 583,
	"./icon-transfer": 7002,
	"./icon-transfer.vue": 7002,
	"./icon-trash": 54699,
	"./icon-trash.vue": 54699,
	"./icon-trolley": 62887,
	"./icon-trolley.vue": 62887,
	"./icon-two-people": 38532,
	"./icon-two-people.vue": 38532,
	"./icon-wall": 46581,
	"./icon-wall.vue": 46581,
	"./icon-weather": 73646,
	"./icon-weather.vue": 73646,
	"./icon-whatsapp": 32127,
	"./icon-whatsapp.vue": 32127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12470;